/**
 * @format
 */
 export const SET_USERS = 'set_users';
 export const TOGGLE_USER_LIST_LOADING = 'toggle_user_list_loading';
 export const CHANGE_USER_CURRENT_PAGE = 'change_user_current_page';
 export const ADD_USER = 'add_user';

 